// hooks/signalr/signalRConfig.js
import * as signalR from '@microsoft/signalr';

export const SIGNALR_CONFIG = {
  reconnectDelays: [0, 2000, 5000, 10000, 30000],
  serverTimeout: 120000,
  keepAliveInterval: 15000,
  logLevel: signalR.LogLevel.Information
};

export const HEARTBEAT_CONFIG = {
  pingInterval: 30000,        // 30 sekunder
  httpInterval: 5 * 60 * 1000 // 5 minuter
};

export const LOCK_CONFIG = {
  renewalInterval: 4 * 60 * 1000, // 4 minuter
  expiryTime: 5 * 60 * 1000       // 5 minuter
};

export const TYPING_CONFIG = {
  debounceDelay: 300,
  autoStopDelay: 3000,
  cleanupDelay: 10000
};

export const createHubUrl = (baseUrl, userId) => {
  return userId
    ? `${baseUrl}/ambulanceScheduleHub?userId=${userId}`
    : `${baseUrl}/ambulanceScheduleHub`;
};

export const createConnection = (hubUrl, token) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => token
    })
    .withAutomaticReconnect({
      // Returnerar null = ge INTE upp. Håll på tills servern är uppe igen.
      nextRetryDelayInMilliseconds: (retryContext) => {
        if (retryContext.elapsedMilliseconds < 30000) return 2000;   // Första 30s: var 2:a sek
        if (retryContext.elapsedMilliseconds < 120000) return 5000;  // 30s–2min: var 5:e sek
        return 10000; // Därefter: var 10:e sek, för alltid
      }
    })
    .configureLogging(signalR.LogLevel.Warning)
    .build();
};